import { VALIDATE_TYPES } from '../../../../../../common/utils/validator'
import i18n from '../../../../../../i18n'

export const TABS_ENUM = {
    form: 1,
    final: 2,
}

export const MODE = {
    INDEPENDENT: 'INDEPENDENT',
    EMBEDDED: 'EMBEDDED',
}

export const STRUCT_KEY_BY_MODE = {
    [MODE.INDEPENDENT]: 'struct',
    [MODE.EMBEDDED]: 'leadFormStruct',
}

export const TABS_ARRAY_BY_MODE = {
    [MODE.INDEPENDENT]: [
        {
            id: TABS_ENUM.form,
            label: i18n.t('Form'),
        },
        {
            id: TABS_ENUM.final,
            label: i18n.t('Thank you'),
        },
    ],
    [MODE.EMBEDDED]: [
        {
            id: TABS_ENUM.form,
        },
    ],
}

export const FORM_KEYS = {
    fields: 'fields',
    fieldsOrder: 'fieldsOrder',
    headerText: 'headerText',
    descriptionText: 'descriptionText',
    linkPrivacyPolicyLink: 'linkPrivacyPolicyLink',
    buttonText: 'buttonText',
}
export const FINAL_KEYS = {
    headerText: 'headerText',
    descriptionText: 'descriptionText',
    imageSrc: 'imageSrc',
    imageDisclaimerText: 'imageDisclaimerText',
}

export const DEFAULT_FORM_FIELDS = {
    firstName: {
        key: 'firstName',
        label: i18n.t('First name'),
        isRequired: true,
    },
    lastName: {
        key: 'lastName',
        label: i18n.t('Last name'),
        isRequired: true,
    },
    email: {
        key: 'email',
        label: i18n.t('Email'),
        isRequired: true,
    },
    phoneNumber: {
        key: 'phoneNumber',
        label: i18n.t('Phone number'),
        isRequired: true,
    },
    company: {
        key: 'company',
        label: i18n.t('Company'),
        isRequired: true,
    },
}

export const INIT_STRUCTURE_BY_MODE = {
    [MODE.INDEPENDENT]: {
        isHasFinalScreen: true,
        form: {
            fields: [
                {
                    isRequired: DEFAULT_FORM_FIELDS.firstName.isRequired,
                    key: DEFAULT_FORM_FIELDS.firstName.key,
                },
                {
                    isRequired: DEFAULT_FORM_FIELDS.lastName.isRequired,
                    key: DEFAULT_FORM_FIELDS.lastName.key,
                },
                {
                    isRequired: DEFAULT_FORM_FIELDS.email.isRequired,
                    key: DEFAULT_FORM_FIELDS.email.key,
                },
                {
                    isRequired: DEFAULT_FORM_FIELDS.phoneNumber.isRequired,
                    key: DEFAULT_FORM_FIELDS.phoneNumber.key,
                },
                {
                    isRequired: DEFAULT_FORM_FIELDS.company.isRequired,
                    key: DEFAULT_FORM_FIELDS.company.key,
                },
            ],
            headerText: 'Form',
            descriptionText: 'Please fill in the form fields',
            linkPrivacyPolicyLink: '',
            buttonText: 'Submit',
        },
        final: {
            headerText: 'Thank you!',
            descriptionText: '',
            imageSrc: '',
            imageDisclaimerText: '',
        },
    },
    [MODE.EMBEDDED]: {
        isHasFinalScreen: false,
        form: {
            fields: [
                {
                    isRequired: DEFAULT_FORM_FIELDS.firstName.isRequired,
                    key: DEFAULT_FORM_FIELDS.firstName.key,
                },
                {
                    isRequired: DEFAULT_FORM_FIELDS.email.isRequired,
                    key: DEFAULT_FORM_FIELDS.email.key,
                },
            ],
            headerText: 'Form',
            descriptionText: 'Please fill in the form fields',
            linkPrivacyPolicyLink: '',
            buttonText: 'Submit',
        },
    },
}

export const INIT_VALIDATE_STRUCTURE_BY_MODE = {
    [MODE.INDEPENDENT]: {
        hasError: false,
        form: {},
        final: {},
    },
    [MODE.EMBEDDED]: {
        hasError: false,
        form: {},
    },
}

export const VALIDATE_RULES_BY_MODE = {
    [MODE.INDEPENDENT]: {
        form: {
            buttonText: [VALIDATE_TYPES.required],
        },
        final: {
            headerText: [VALIDATE_TYPES.required],
        },
    },
    [MODE.EMBEDDED]: {
        form: {
            buttonText: [VALIDATE_TYPES.required],
        },
    },
}

export const VALIDATE_MESSAGES = {
    [VALIDATE_TYPES.required]: 'This field is required',
}
